import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "22",
  fill: "none",
  viewBox: "0 0 23 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "21",
      height: "21",
      x: "1",
      y: ".5",
      fill: "#F2F4F7",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "21",
      height: "21",
      x: "1",
      y: ".5",
      stroke: "#E4E6EB",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#667085",
      d: "M18.5 4v1.556h-.778l-3.889 5.833V18H9.167v-6.611l-3.89-5.833H4.5V4zM7.147 5.556l3.575 5.362v5.526h1.556v-5.526l3.575-5.362z"
    }, null, -1)
  ]))]))
}
export default { render: render }